// 当前应用共配请求相关Api
import { defineAppApi } from '@zto/zpage'
import { reportTraceData } from '@zto/tuxi-operate-web-base'
import type { App } from '@zto/zpage'

/** 数据Api接口 */
export default defineAppApi((app: App) => {
  return {
    baseUrl: app.env.apiUrl,

    inner: { timeout: 30000 },

    methods: api => {
      return {
        /**
         * 获取兔喜组织树
         */
        async getTuxiDeptTree(params: any) {
          const res = await api.fetch({
            url: 'basic/dept/tuxi/tree',
            data: params
          })
          return res?.data
        },

        /**
         * 获取商业组织树
         */
        async getBusinessDeptTree(params: any) {
          const res = await api.fetch({
            url: 'basic/dept/business/tree',
            data: params
          })
          return res?.data
        },

        /**
         * 获取商品品类树
         */
        async getProductCategoryTree(params: any) {
          const res = await api.fetch({
            url: 'basic/product/category/tree',
            data: params
          })
          return res?.data
        },

        /**
         * 获取用户自定义列
         */
        async getCustomColumnList(params: any) {
          const res = await api.fetch({
            url: 'basic/page/column/custom/list',
            data: params
          })
          return res?.data
        },

        /**
         * 保存用户自定义列
         */
        async editCustomColumnList(params: any) {
          const res = await api.fetch({
            url: 'basic/page/column/custom/edit',
            data: params
          })
          return res?.data
        },

        /**
         * 设置默认自定义列
         */
        async setDefaultCustomColumn(params: any) {
          const res = await api.fetch({
            url: 'basic/page/column/custom/default',
            data: params
          })
          return res?.data
        },

        // 全部省市区
        async getAreaList() {
          // return api.request({
          //   url: 'tuxi.web.WebCommonService.getAreaList'
          // })
          return []
        },

        // 获取用户所有组织服务范围并集,格式化街道
        async getAreaListByAccount(accountCode: string) {
          const res = await api.request({
            url: 'tuxi.spm.boss.srm.agentScopeAreaInfo',
            data: { accountCode }
          })
          return { deptScopeList: res, deptScopeMergedList: null }
        },

        // 获取用户-量本利-省市区
        async getAreaListByQcp() {
          return api.fetch({
            url: 'kdcs.listAllPDC'
          })
        },



        // 自定义埋点上报方法
        reportTraceData(app: any, event: any) {
          return reportTraceData(app, event)
        }
      }
    }
  }
})
